import React from 'react';
import { Box, Button, Flex, Text, useTheme } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AleaPlusIcon from '../../icons/AleaPlusIcon.tsx';
import AleaArrowRightIcon from '../../icons/AleaArrowRightIcon.tsx';

interface Props {
  residentName: string;
  residentId?: string | null;
}

const ResidentCreatedSuccessfully: React.FC<Props> = ({ residentName, residentId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Flex direction="column" alignItems="flex-start" p="24px" bg="white" borderRadius="20px">
      <Flex w="100%" alignItems="center" justifyContent="space-between" mb="50px">
        <Box>
          <Text fontSize="15px" fontWeight="300" color="#000">
            {t('newResident')}: {residentName}
          </Text>
          <Text fontSize="25px" fontWeight="500" lineHeight="normal" maxWidth="485px">
            {t('newResidentSuccessHeadline')}
          </Text>
        </Box>
        <Box>
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="81" viewBox="0 0 80 81" fill="none">
            <rect y="0.564453" width="80" height="80" rx="40" fill="#66EA6D"/>
            <path d="M22.1084 43.493L35.7715 54.8778L57.8913 26.2524" stroke="white" strokeWidth="9.14286" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </Box>
      </Flex>

      <Flex direction="column" gap="10px" w="100%">
        <Button onClick={() => navigate(0)} leftIcon={<AleaPlusIcon size={25} color="white" />} colorScheme="teal" variant="solid" alignSelf="flex-start" height="50px" borderRadius="20px" p="15px" fontSize="18px" fontWeight={400}>
          {t('addAnotherResident')}
        </Button>

        <Button onClick={() => navigate('/hardware?tag=free')} leftIcon={<AleaArrowRightIcon size={18} color={theme.colors.alea[500]} />} variant="outline" alignSelf="flex-start" height="50px" borderRadius="20px" p="15px" fontSize="18px" fontWeight={400} borderColor="alea.500" color="alea.500">
          {t('assignHardware')}
        </Button>

        <Button onClick={() => residentId ? navigate(`/residents/${residentId}`) : navigate('/residents')} leftIcon={<AleaArrowRightIcon size={18} color={theme.colors.alea[500]} />} variant="outline" alignSelf="flex-start" height="50px" borderRadius="20px" p="15px" fontSize="18px" fontWeight={400} borderColor="alea.500" color="alea.500">
          {t('toResidentProfile', { name: residentName })}
        </Button>

        <Button onClick={() => navigate('/residents')} variant="link" alignSelf="flex-start" height="50px" borderRadius="20px" p="15px" fontSize="16px" fontWeight={400} color="alea.500" textDecoration="underline">
          {t('backToResidentList')}
        </Button>
      </Flex>
    </Flex>
  );
}

export default ResidentCreatedSuccessfully;


